import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  const legal = [
    { to: "/legal/cgv", label: t("footer.cgv") },
    { to: "/legal/cgu", label: t("footer.cgu") },
    { to: "/legal/privacy", label: t("footer.privacy") },
    { to: "/legal/cookies", label: t("footer.cookies") },
  ];
  return (
    <footer data-testid="site-footer" className="border-t border-[#E6EBF1] bg-[#F6F9FC]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div className="space-y-4">
            <Logo light />
            <p className="text-sm text-[#425466] leading-relaxed max-w-xs">{t("footer.tagline")}</p>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0A2540] mb-4">
              {t("footer.legalTitle")}
            </h4>
            <ul className="space-y-2.5">
              {legal.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-[#425466] hover:text-[#635BFF] transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0A2540] mb-4">
              {t("footer.contactTitle")}
            </h4>
            <Link to="/contact" className="text-sm text-[#635BFF] hover:underline font-medium">
              {t("nav.contact")} →
            </Link>
            <p className="text-sm text-[#425466] mt-2">+41 22 555 01 40 — Geneva, CH</p>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-[#E6EBF1] space-y-3">
          <p data-testid="legal-mention" className="text-[11px] leading-relaxed text-slate-500">
            UBP/UCP Investment Services (Pty) Ltd is a private Company, registred for EU Zone as an
            Authorised Financial Services issued by FSCA FSP53152
          </p>
          <p className="text-[11px] text-slate-400">
            © {new Date().getFullYear()} UCP — Union Crypto Private. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
